import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/primary-arrow-left.png'
import _imports_1 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-b02ec0f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { computed, nextTick, onMounted, ref } from 'vue';
  import { StoryTag } from '@/types/story';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    list: StoryTag[];
  }
  interface IEmits {
    (event: 'change', tagName: string): void;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    list: null
  },
  emits: ["change"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (event: 'change', tagName: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    list: StoryTag[];
  }

  
  
  const filterRef = ref<HTMLElement>();
  const scrollRef = ref<HTMLElement>();
  const scrollLeft = ref(0);
  const showArrow = ref(false);
  const { locale, t } = useI18n();
  expose({ initScrollArrow });

  onMounted(() => { initScrollArrow(); });
  const tags = computed(() => {
    if (!props.list.length) {
      return [];
    }
    return [
      {
        id: 0,
        name: t('All')
      },
      ...props.list,
    ];
  });

  // 移动距离正负根据实际调整
  async function handleScroll(move: number) {
    const value = Number(scrollRef.value?.scrollLeft);
    scrollRef.value?.scrollTo({ left: value + move });

    await nextTick();
    scrollLeft.value = Number(scrollRef.value?.scrollLeft);
  }

  function initScrollArrow() {
    if (scrollRef.value && filterRef.value) {
      showArrow.value = scrollRef.value.scrollWidth > filterRef.value.scrollWidth;
    }
  }

  const tagId = ref(-1);
  function handleSelectedTag(tag: StoryTag | { id: number; name: string; }) {
    tagId.value = tag.id;
    emits('change', tag.name);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "filterRef",
    ref: filterRef,
    class: _normalizeClass(["filter-tag-wrapper", `lang-${_unref(locale)}`])
  }, [
    (scrollLeft.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "arrow hidden-xs-only",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleScroll(-100)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "scrollRef",
      ref: scrollRef,
      class: "list-box"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", { selected: tagId.value === tag.id }]),
          onClick: ($event: any) => (handleSelectedTag(tag))
        }, _toDisplayString(tag.name), 11, _hoisted_1))
      }), 128))
    ], 512),
    (showArrow.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "arrow hidden-xs-only",
          src: _imports_1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleScroll(100)))
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})